<template>
  <div class="slider-container">
    <div class="slider-list" ref="sliderList">
      <div v-for="(item, idx) in products" :key="item.title" class="slider-item" 
      
        :class="{ active: idx === activeIndex }">
        <img :src="item.image" class="product-img" />
        <h3 class="product-title">{{ item.title }}</h3>
      </div>
    </div>
    <div class="slider-dots">
      <span v-for="(item, idx) in products" :key="idx" class="dot" :class="{ active: idx === activeIndex }"
        @click="scrollToItem(idx)" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSlider",
  props: {
    products: {
      type: Array,
      required: true,
      default: () => [],
      validator: (products) => {
        return products.every(product => 
          product.hasOwnProperty('image') && 
          product.hasOwnProperty('title') &&
          typeof product.image === 'string' &&
          typeof product.title === 'string'
        );
      }
    },
    initialActiveIndex: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0
    }
  },
  data() {
    return {
      activeIndex: this.initialActiveIndex,
    };
  },
  watch: {
    products: {
      handler(newProducts) {
        // Reset activeIndex if it's out of bounds
        if (this.activeIndex >= newProducts.length) {
          this.activeIndex = 0;
        }
      },
      immediate: true
    },
    initialActiveIndex: {
      handler(newIndex) {
        if (newIndex >= 0 && newIndex < this.products.length) {
          this.activeIndex = newIndex;
        }
      }
    }
  },
  methods: {
   
    scrollToItem(index) {
      this.activeIndex = index;
      
      // Get the slider container and item
      const sliderList = this.$refs.sliderList;
      const items = sliderList.children;
      
      if (items[index]) {
        const item = items[index];
        const containerWidth = sliderList.offsetWidth;
        const itemWidth = item.offsetWidth;
        const itemOffsetLeft = item.offsetLeft;
        
        // Calculate scroll position to center the item
        const scrollLeft = itemOffsetLeft - (containerWidth / 2) + (itemWidth / 2);
        
        // Smooth scroll to the calculated position
        sliderList.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }
  }
};
</script>
<style scoped>
* {
  font-family: inherit;
}

.slider-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.slider-list {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  width: 100%;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  gap: 20px;
  /* Responsive item sizing */
}

.slider-item {
  flex: 0 0 100%;
  max-width: 100%;
}

@media (min-width: 600px) {
  .slider-item {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 900px) {
  .slider-item {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
  }
}

@media (min-width: 1200px) {
  .slider-item {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.slider-list::-webkit-scrollbar {
  display: none;
}

.slider-list {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.slider-item {
  background: white;
  border-radius: 18px;
  border: 1px solid whitesmoke;
  box-shadow: 0 4px 16px #0001;
  padding: 5px;
  width: 370px;
  margin: 20px 0;
  min-width: 270px;
  max-width: 370px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: border-color 0.25s, box-shadow 0.2s;
  scroll-snap-align: center;
}
.dark .slider-item {
  background: rgb(49, 49, 49);
  border: 1px solid #333;
}
.dark .product-img{
  border: 1px solid #333;
}
.dark .product-title{
  color: #fff;
}



.product-img {
  width: 100%;
  height: 230px;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px #0001;
  border: 1px solid whitesmoke;
}

.product-title {
  color: #184c94;
  font-size: 1rem;
  font-weight: 600;
  padding: 10px 2px;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
}

.slider-dots {
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
}

.dot {
  display: inline-block;
  height: 6px;
  border-radius: 4px;
  background: #184c94;
  width: 24px;
  opacity: 0.25;
  transition: width 0.3s, height 0.3s, opacity 0.2s;
  cursor: pointer;
}

.dark .dot{
  background: #fff;
}

.dot.active {
  width: 100px;
  height: 6px;
  opacity: 1;
}

@media (max-width: 768px) {
  .slider-list {
    gap: 20px;
    padding: 0 10px;
  }

  .slider-item {
    min-width: 250px;
    max-width: 300px;
  }
  .slider-dots {
    gap: 10px;
    flex-wrap: wrap;
  }
  .dot{
    width: 16px;
  }
  .dot.active {
    width: 30px;
  }
}
</style>